<template>
    <div>
        <data-table ref="raids"
                    :api-route="getRaidsUrl"
                    :api-view-set="table.apiViewSet"
                    :name="table.name"
                    :title="table.title"
                    :columns="table.columns"
                    :search="table.search"
                    :filters="table.filters ? table.filters : []"
                    :actions="table.actions"
                    :orderings="table.orderings"
                    :initial-filters="table.initialFilters"
                    :initial-orderings="table.initialOrderings"
                    :row-actions="table.rowActions"
                    :key="table.key"
                    :destroy-title="'Удаление рейда'"
                    @object-modal-triggered="onModalTriggered">
        </data-table>

        <b-modal id="raid-modal" hide-footer hide-header size="lg" @hidden="onModalHide">
            <template #default>
                <raid-modal-detail v-if="isCatching"
                                   :request="request"
                                   :raid-id="selectedRaidId"
                                   key="selectedRaidId"
                                   @object-modal-closed="$bvModal.hide('raid-modal')"
                                   @object-modal-created="onRaidObjectCreated"
                                   @object-modal-updated="onRaidObjectUpdated" />

                <monitoring-raid-modal-detail v-if="isMonitoring"
                                              :request="request"
                                              :raid-id="selectedRaidId"
                                              key="selectedRaidId"
                                              @object-modal-closed="$bvModal.hide('raid-modal')"
                                              @object-modal-created="onRaidObjectCreated"
                                              @object-modal-updated="onRaidObjectUpdated" />

                <release-raid-modal-detail v-if="isRelease"
                                           :defer-update-event="true"
                                           :request="request"
                                           :raid-id="selectedRaidId"
                                           :animal-filters="animalFilters"
                                           key="selectedReleaseRaidId"
                                           @object-modal-closed="$bvModal.hide('raid-modal')"
                                           @object-modal-updated="onReleaseRaidObjectUpdated"
                                           @object-modal-created="onReleaseRaidObjectCreated" />

            </template>
        </b-modal>

    </div>
</template>

<script>
    import actions, {AvailableAction} from "../../../components/Table/actions";
    import api from "../../../api";
    import DataTable from "../../../components/Table/DataTable";
    import RaidModalDetail from "./RaidModalDetail";
    import {mapGetters} from "vuex";
    import {Raid} from "./raid";
    import ReleaseRaidModalDetail from "@/pages/AppPages/Raids/ReleaseRaidModalDetail";
    import {ACTIVITIES } from "@/store/auth/auth";
    import {RequestStatus} from "@/pages/AppPages/Requests/request";
    import MonitoringRaidModalDetail from "@/pages/AppPages/Raids/MonitoringRaidModalDetail.vue";
    import {Animal} from "@/pages/AppPages/Animals/animal";

    export default {
        name: "RaidsList",
        components: {
            MonitoringRaidModalDetail,
            ReleaseRaidModalDetail,
            RaidModalDetail,
            DataTable,
        },
        props: {
            request: { type: Object, default: () => { return {} }},
            animalFilters: { type: Array, default: () => { return [] } }
        },
        data() {
            return {
                selectedRaidId: null,
                catchingRaidsTable: {
                    name: 'catching-raids-table',
                    apiViewSet: api.raids.default,
                    key: 'catching-raids-table',
                    title: 'Рейды',
                    columns: [
                        { name: 'id', 'title': 'Рейд', alwaysVisible: true,
                            modal: {
                                modalName: 'raid-modal',
                            },
                            cellComponentName: 'RaidNumberStatusCell',
                            cellComponentPath: 'src/pages/DataTableCells/'
                        },
                        { name: 'planned_date_only', 'title': 'Запланирован', extraDataFrom: 'planned_time_only'},
                        { name: 'actual_date_only', 'title': 'Проведен', extraDataFrom: 'actual_time_only'},
                        { name: 'address_object.municipality_object.short_name', 'title': 'Муниципалитет'},
                        { name: 'description', 'title': 'Описание'},
                        { name: 'planned_count', 'title': 'К отлову'},
                        { name: 'caught_count', 'title': 'Поймано'},
                        { name: 'comment', 'title': 'Комментарий'},
                        { name: 'created_date_only', 'title': 'Создан', extraDataFrom: 'created_time_only'},
                    ],
                    orderings: [
                        'id',
                        {'status_object': 'status'},
                        'created_at',
                        {'planned_date_only': 'planned_at'},
                        {'actual_date_only': 'actual_date'}
                    ],
                    actions: [],
                    rowActions: [],
                    filters: [],
                    initialFilters: { 'request': this.request.id },
                    initialOrderings: { 'id': 2 }
                },
                releaseRaidsTable: {
                    name: 'release-raids-table',
                    apiViewSet: api.raids.default,
                    key: 'release-raids-table',
                    title: 'Рейды',
                    columns: [
                        { name: 'id', 'title': 'Рейд', alwaysVisible: true,
                            modal: {
                                modalName: 'raid-modal',
                            },
                            cellComponentName: 'RaidNumberStatusCell',
                            cellComponentPath: 'src/pages/DataTableCells/'
                        },
                        { name: 'release_count', 'title': 'К выпуску'},
                        { name: 'planned_date_only', 'title': 'Запланирован', extraDataFrom: 'planned_time_only'},
                        { name: 'actual_date_only', 'title': 'Проведен', extraDataFrom: 'actual_time_only'},
                        { name: 'description', 'title': 'Описание'},
                        { name: 'comment', 'title': 'Комментарий'},
                        { name: 'created_date_only', 'title': 'Создан', extraDataFrom: 'created_time_only'},
                    ],
                    orderings: [
                        'id',
                        {'status_object': 'status'},
                        'created_at',
                        {'planned_date_only': 'planned_at'},
                        {'actual_date_only': 'actual_date'}
                    ],
                    actions: [],
                    rowActions: [],
                    filters: [],
                    initialFilters: { 'request': this.request.id },
                    initialOrderings: { 'id': 2 }
                },
                monitoringRaidsTable: {
                    name: 'monitoring-raids-table',
                    apiViewSet: api.raids.default,
                    key: 'monitoring-raids-table',
                    title: 'Рейды',
                    columns: [
                        { name: 'id', 'title': 'Рейд', alwaysVisible: true,
                            modal: {
                                modalName: 'raid-modal',
                            },
                            cellComponentName: 'RaidNumberStatusCell',
                            cellComponentPath: 'src/pages/DataTableCells/'
                        },
                        { name: 'planned_date_only', 'title': 'Запланирован', extraDataFrom: 'planned_time_only'},
                        { name: 'actual_date_only', 'title': 'Проведен', extraDataFrom: 'actual_time_only'},
                        { name: 'address_object.municipality_object.short_name', 'title': 'Муниципалитет'},
                        { name: 'description', 'title': 'Описание'},
                        { name: 'caught_count', 'title': 'Поймано'},
                        { name: 'comment', 'title': 'Комментарий'},
                        { name: 'created_date_only', 'title': 'Создан', extraDataFrom: 'created_time_only'},
                    ],
                    orderings: [
                        'id',
                        {'status_object': 'status'},
                        'created_at',
                        {'planned_date_only': 'planned_at'},
                        {'actual_date_only': 'actual_date'}
                    ],
                    actions: [],
                    rowActions: [],
                    filters: [],
                    initialFilters: { 'request': this.request.id },
                    initialOrderings: { 'id': 2 }
                },
            }
        },
        computed: {
            ...mapGetters(['ability', 'userOrganizationId', 'isSuperuser']),
            getRaidsUrl() {
                return api.raids.default.list();
            },
            table() {
                switch (this.request.activity) {
                    case ACTIVITIES.CATCHING:
                        return this.catchingRaidsTable
                    case ACTIVITIES.RELEASE:
                        return this.releaseRaidsTable
                    case ACTIVITIES.MONITORING:
                        return this.monitoringRaidsTable
                    default:
                        return {}
                }
            },
            isCatching() {
                return this.request.activity === ACTIVITIES.CATCHING
            },
            isRelease() {
                return this.request.activity === ACTIVITIES.RELEASE
            },
            isMonitoring() {
                return this.request.activity === ACTIVITIES.MONITORING
            }
        },
        methods: {
            onModalTriggered(modalName, objectId) {
                if (modalName === 'raid-modal') {
                    this.selectedRaidId = objectId;
                    this.$bvModal.show(modalName);
                }
            },

            onRaidObjectCreated() {
                this.$refs.raids.reload();
                this.$bvModal.hide('raid-modal');
            },

            onRaidObjectUpdated(e) {
                this.request.caughtCount = e['request_object']['caught_count'];
                this.$refs.raids.updateRow(e);
                this.$bvModal.hide('raid-modal');
                this.$emit('request-caught-count-updated');
            },

            onReleaseRaidObjectCreated() {
                this.$refs.raids.reload();
                this.$bvModal.hide('raid-modal');
                this.$emit('request-release-count-updated');
            },

            onReleaseRaidObjectUpdated(e) {
                this.$refs.raids.updateRow(e);
                this.$emit('request-release-count-updated');
            },

            onModalHide(e) {
                this.$emit('request-release-count-updated');
            }

        },
        mounted() {
            // this.raidsTable.initialFilters['request'] = this.request.id

            const isWIP = this.request.status === RequestStatus.WIP;

            const canCreateCatchingRaid = this.isCatching && this.request.caughtCount < this.request.animalsCount;
            const canCreateReleaseRaid = this.isRelease && this.request.animalsAvailableToRelease.length > 0;
            const canCreateMonitoringRaid = this.isMonitoring;

            if (isWIP && (canCreateCatchingRaid || canCreateReleaseRaid || canCreateMonitoringRaid)) {
                this.table.actions.push(
                    actions.create(() => {
                            this.selectedRaidId = null;
                            this.$bvModal.show('raid-modal')
                        }, this.ability.can('create', 'Raid')
                                    && (this.request.assignedToId === this.userOrganizationId || this.isSuperuser)
                                    && this.request.contract
                    )
                );
            }

            if (this.ability.can('destroy', 'Raid')) {
                this.table.rowActions.push(new actions.objectDelete(Raid))
            }


        }
    }
</script>

<style scoped>

</style>